import type { GatsbyImageProps, IGatsbyImageData } from 'gatsby-plugin-image';
import { GatsbyImage } from 'gatsby-plugin-image';

import { withErrorBoundary } from '../ErrorBoundary';

import { StyledImageWrapper, StyledWrapper } from './Styled';

type NecessaryImageProps = Omit<GatsbyImageProps, 'image' | 'alt'>;

export type ImageProps = NecessaryImageProps & {
  altText: string;
  asset: {
    gatsbyImageData: IGatsbyImageData;
  };
  position: 'Left' | 'Center';
  size: 'Small' | 'Medium' | 'Large';
  roundedCornerPosition?: 'Top Left' | 'Bottom Left' | 'Top Right' | 'Bottom Right';
};

const getRoundedCornerClass = (position?: 'Top Left' | 'Bottom Left' | 'Top Right' | 'Bottom Right'): string => {
  if (!position) return '';

  const classMap = {
    'Bottom Left': 'rounded-bl-[6rem]',
    'Bottom Right': 'rounded-br-[6rem]',
    'Top Left': 'rounded-tl-[6rem]',
    'Top Right': 'rounded-tr-[6rem]',
  };

  return `${classMap[position]} overflow-hidden`;
};

const Image = ({ altText, asset, position = 'Left', size = 'Medium', roundedCornerPosition }: ImageProps) => {
  if (!asset?.gatsbyImageData) {
    return null;
  }

  return (
    <StyledWrapper position={position}>
      <StyledImageWrapper size={size} className={getRoundedCornerClass(roundedCornerPosition)}>
        <GatsbyImage
          image={asset.gatsbyImageData}
          alt={altText}
          objectFit="cover"
          style={{ height: '100%', margin: '0 auto' }}
        />
      </StyledImageWrapper>
    </StyledWrapper>
  );
};

export default withErrorBoundary(Image, { componentName: 'Image' });
